// This component creates the Pivot section where you select which day of the week to display.
// This also pulls the weekdictionary information for each day, collects the ScheduledMenus for that day,
// then converts it into a format that can be used by the MenuSection component.

import { DayOfWeek, Pivot, PivotItem, Text } from "@fluentui/react";
import dayjs from "dayjs";
import React from "react";
import { useSelector } from "react-redux";
import { weekStartSelector } from "../../selectors/diningSelector";
import styles from "../../styles/menuPreview.module.css";
import MenuSection from "./MenuSection";
import { PreviewMenu } from "./types/menuPreviewTypes";

export interface MenuWeekdaySelectorProps {
  weeklyMenu: Array<PreviewMenu[]>;
}

// Creates an array of PivotItems, one for each weekday that has ScheduledMenu items.
const tabsByWeekday = (weeklyMenu: Array<PreviewMenu[]>) => {
  // Store a list of PivotItems to be displayed in our component.
  const pivotItemList: JSX.Element[] = [];

  weeklyMenu.forEach((week, i) => {
    // Add a PiviotItem for that day to our PivotItemList.
    // MenuSection seperates and displays lists of ScheduledMenu items.
    pivotItemList.push(
      <PivotItem
        className={styles.pivotStyle}
        headerText={DayOfWeek[i]}
        headerButtonProps={{
          "data-order": i,
          "data-title": DayOfWeek[i],
        }}
        key={i}
      >
        <MenuSection previewMenuList={week} key={DayOfWeek[i]} />
      </PivotItem>,
    );
  });
  // Remove weekends
  pivotItemList.shift();
  pivotItemList.pop();
  return pivotItemList;
};

// Displays a set of PivotItems which, when selected, display a MenuSection for the corresponding day.
const MenuWeekdaySelector = ({ weeklyMenu }: MenuWeekdaySelectorProps) => {
  const weekStart = useSelector(weekStartSelector);
  return (
    <div>
      <Text className={styles.menuDate}>Menu for the week of {dayjs(weekStart).toDate().toLocaleDateString()}</Text>
      <Pivot defaultSelectedKey={"0"} overflowBehavior={"menu"} overflowAriaLabel="more items">
        {tabsByWeekday(weeklyMenu)}
      </Pivot>
    </div>
  );
};

export default MenuWeekdaySelector;
